import { PopUtils } from '../../../../framework/components/pop/pop-utils';
import { WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import { WizBasePopUp, WizPopUp, PopUpManager } from '@wizeoo/akm-component-lib';
import { Component, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef } from '@angular/core';

/**
 * PopUp de création d'un template de widgets
 */
@Component({
  templateUrl: 'imagesource.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageSourcePop extends WizBasePopUp {
  /** Méthode statique de création/affichage d'un choix de source d'image */
  public static show(
    pRelatedElement: HTMLElement,
    pCallback: (pMode: string) => void
  ) {
    const pop: WizPopUp = new WizPopUp(
      ImageSourcePop,
      false,
      false,
      null,
      '100px',
      '65px',
      pCallback
    );
    const pos: DOMRect = pRelatedElement.getBoundingClientRect();

    const bestXY: [number, number] = PopUtils.setPopCoord(pos, pop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    pop.customPosition = targetPosition;

    if (PopUpManager.exist(pop)) {
      // suppression de l'instance existante
      pop.hide();
    }
    pop.show();
    
  }

  constructor(protected cdref: ChangeDetectorRef, public elementRef: ElementRef) {
    super();
  }

  public mode: string = null;

  public showMode(origin: string): void {
    this.mode = origin;
    // console.log('showMode');
    this.hide();
  }

  show() {
    super.show();
    this.callback = this.datas;
    // console.log('popShow', this.datas);
  }

  onHide(): void {
    // console.log('popHide', this.datas);
    if(!!this.callback) {
      this.callback(this.mode);
    }
  }
}
